// extracted by mini-css-extract-plugin
export var sticky = "Header-module--sticky--2Pemh";
export var categoryPage = "Header-module--category-page--3ocyO";
export var title = "Header-module--title--2NCtK";
export var link = "Header-module--link--4ebYS";
export var screenReaderText = "Header-module--screenReaderText--2ZW3f";